<template>

    <Head title="Tools" />
    <template v-if="result">
        {{ result }}
    </template>
    <h1 class="mb-8 text-3xl font-bold">Tools</h1>

    <div class="grid grid-cols-1 gap-4 mt-8 sm:grid-cols-5">
        <Card-Link @click="isLoading = true" iconName="domains" title="Update Domains DNS Info" text=" Erneuert alle gespeicherten DNS-Daten der Domains.
                        Dazu gehören: A, NS, MX, DKIM & DMARC" link="tools/refresh-dns" />
    </div>

    <div class="flex bg-primary-200 border-t border-gray-100 absolute h-full w-full left-0 top-0 z-50 content-center justify-center opacity-85"
        :class="{hidden: !isLoading}">
        <loading-button :loading="isLoading" class="btn-primary text-white text-lg" type="submit">Update der
            Datenbank...</loading-button>
    </div>

</template>

<script>
import { Head } from '@inertiajs/inertia-vue3';
import Layout from '@/Shared/Layout'
import CardLink from '@/Shared/CardLink'
import { Link } from '@inertiajs/inertia-vue3'
import LoadingButton from '@/Shared/LoadingButton'

export default {
    components: {
        Head,
        Link,
        CardLink,
        LoadingButton
    },
    layout: Layout,
    props: {
        showResult: Boolean,
        receivedData: Array
    },
    data() {
        return {
            isLoading: false
        }
    },
    setup(props) {
        //- add loader to update function
        
        return {

        }
    },
}
</script>
